export default __webpack_public_path__ + "static/media/fluent-social.f96de0fa.png";